import { pipe } from 'fp-ts/lib/function';
import * as D from 'io-ts/Decoder';

export const ValidDate = pipe(
	D.string,
	D.parse((s) => {
		const date = new Date(s);
		if (isNaN(date.getTime())) {
			return D.failure(s, 'valid date');
		}

		return D.success(s);
	})
);
